module TemplateConfiguration.Helper

open Shared

let isTemplateEditableOrCreatable (userData : UserData) =
    userData.AssignedRoles
    |> List.exists (fun r -> r = Administrator || r = Dispatcher)
